import React, { useState } from 'react';
import Sidebar from '../Sidebar';
import styles from './LearningManagerLayout.module.scss';
import classNames from 'classnames';

interface LearningManagerLayoutProps {
	children?: React.ReactNode;
}

const LearningManagerLayout: React.FC<LearningManagerLayoutProps> = ({
	children
}) => {
	const [activeKey, setActiveKey] = useState<string>('courses');
	const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(
		() => window.innerWidth <= 576
	);

	const handleNavigate = (key: string, path?: string) => {
		setActiveKey(key);
		// history.push(path ?? '/learning-manager');
	};

	return (
		<div className={styles.layout}>
			<Sidebar
				onCollapse={setSidebarCollapsed}
				activeKey={activeKey}
				onNavigate={handleNavigate}
			/>
			<main
				className={classNames(styles.main, {
					[styles['main--collapsed']]: sidebarCollapsed
				})}
			>
				<div className={styles.content}>{children}</div>
			</main>
		</div>
	);
};

export default LearningManagerLayout;
